import { AuthPartialStoreState } from '../auth.reducer';

export const getStep = (state: AuthPartialStoreState) => state.auth.recoverPassword.step;

export const getLoading = (state: AuthPartialStoreState) => state.auth.recoverPassword.loading;

export const getError = (state: AuthPartialStoreState) => state.auth.recoverPassword.error;

export const getDone = (state: AuthPartialStoreState) => state.auth.recoverPassword.done;

export const getAuthAccessToken = (state: AuthPartialStoreState) => state.auth.recoverPassword.authAccessToken;
